<template>
    <div class="modal base-modal upgrade-show-modal">
        <div :class="['modal-content', modalClasses]">
            <base-modal-close @close-modal="hideModal" />

            <transition name="fade" mode="out-in">
                <intro
                    v-if="steps.intro === upgradeShowModal.step"
                    @change-step-next="changeStep(steps.showInformation)"
                />

                <show-information
                    v-if="steps.showInformation === upgradeShowModal.step"
                    :show="show"
                    @submit="changeStep(steps.success)"
                />

                <success
                    v-if="steps.success === upgradeShowModal.step"
                    :data="{ type: 'migrate' }"
                    :processing="isProcessing"
                    @proceed="finishUpgrading"
                />
            </transition>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { steps } from '@/utils/config/upgradeShowModal';
import Intro from '@/components/Shows/UpgradeShow/Intro';
import ShowInformation from '@/components/Shows/UpgradeShow/ShowInformation';
import Success from '@/components/Shows/AddShow/Steps/Success';

export default {
    components: {
        Intro,
        ShowInformation,
        Success,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    data: () => ({
        steps,
        isProcessing: false,
    }),

    computed: {
        ...mapState({
            user: state => state.user || {},
            upgradeShowModal: state => state.UIState.upgradeShowModal,
        }),

        /**
         * Returns modal classes.
         *
         * @returns {object} Modal classes.
         */
        modalClasses() {
            return {
                'large-content': [this.steps.intro, this.steps.showInformation, this.steps.paymentInformation].includes(this.upgradeShowModal.step),
            };
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Hide modal
         */
        hideModal() {
            this.changeUIState({
                upgradeShowModal: { visible: false },
            });
        },

        /**
         * Changes step.
         *
         * @param {number} step Current step.
         */
        changeStep(step) {
            this.changeUIState({
                upgradeShowModal: {
                    ...this.upgradeShowModal,
                    step,
                },
            });
        },

        /**
         * Finishes upgrading process.
         */
        async finishUpgrading() {
            this.isProcessing = true;

            await this.$store.dispatch('loadShows', { force: true });

            this.isProcessing = false;

            this.hideModal();
            this.$router.push(`/shows/${this.show.hash}/episodes`);
        },
    },
};
</script>
